import useMultiEquipmentTrackingEnabled from 'hooks/settings/useMultiEquipmentTrackingEnabled/useMultiEquipmentTrackingEnabled';
import { ActivityReportType } from '../ActivityReportFilter/ActivityReportFilter';
import { remainingDataItemId } from 'utils/constants/utilConstants';
import { IActivityReportRowInfo } from './ActivityReportData';
import useActivityReportExportColumns, { buildActivityReportExportColumnsData } from './useActivityReportExportColumns';

export default function useActivityReportExport(
  secondaryReportType?: ActivityReportType,
  filterReportType?: ActivityReportType,
  filterId?: string
) {
  const shouldIncludeEquipmentColumns =
    secondaryReportType === ActivityReportType.BY_EQUIPMENT ||
    (filterReportType === ActivityReportType.BY_EQUIPMENT && filterId !== remainingDataItemId);

  const { orderedColumns, exportColumnsByKey } = useActivityReportExportColumns(shouldIncludeEquipmentColumns);
  const hasMultiEquipmentTracking = useMultiEquipmentTrackingEnabled();
  const includeAddOns = hasMultiEquipmentTracking && shouldIncludeEquipmentColumns;

  function getExportData<DataType extends IActivityReportRowInfo>(
    data: DataType[],
    customColumns: (row: DataType) => object
  ) {
    return data.map((row) => {
      const total = includeAddOns ? row.totalHours + row.addOnTime : row.totalHours;

      return {
        ...customColumns(row),
        ...buildActivityReportExportColumnsData(orderedColumns, exportColumnsByKey, row, total),
      };
    });
  }

  return getExportData;
}
